/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.CertMainResponseDto>>;
export function request(params: API.basics.certMain.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/certMain/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
